//register screen
import React, { useState } from 'react'
import { Grid, Container, Row } from '@nextui-org/react'
import { auth } from '../config/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { firestore } from '../config/firebase';
import { collection, setDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Text, Badge, Spacer, Loading, Dropdown } from '@nextui-org/react';
import useApi from '../Hooks/useApi';

const Register = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [confidentialCode, setConfidentialCode] = useState('')
    const [senderName, setSenderName] = useState('')
    const [error, setError] = useState('')
    const { code } = useApi();
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const checkEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase())
    }

    const handleSubmit = async (e) => {
        setLoading(true)
        if (email === '' || password === '' || firstname === '' || lastname === '' || confirmPassword === '' || confidentialCode === '' || senderName === '') {
            setLoading(false)
            return setError('Veuillez remplir tous les champs.')
        }
        if (password.length < 6) {
            setLoading(false)
            return setError('Le mot de passe doit contenir au moins 6 caractères.')
        }
        if (password !== confirmPassword) {
            setLoading(false)
            return setError('Les mots de passe ne correspondent pas.')
        }
        if (confidentialCode !== code.code) {
            setLoading(false)
            return setError('Code confidentiel incorrect.')
        }
        if (!checkEmail(email)) {
            setLoading(false)
            return setError('Veuillez entrer une adresse email valide.')
        }
        try {
            await createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
                // Signed in
                const collectionRef = collection(firestore, "users");
                const user = userCredential.user;
                const docRef = setDoc(doc(collectionRef, user.uid), {
                    email: email,
                    firstname: firstname,
                    lastname: lastname,
                    role: 'user',
                    senderName: senderName
                });
            })
            navigate('/dashboard')
        } catch (error) {
            setError(error.message)
        }
        setError('')
        setLoading(false)
    }

    return (
        <Container gap={2} justify="center">
            <Spacer y={10} />
            <Row justify='center'>
                <Text h2>Créer un compte</Text>
            </Row>
            {error ?
                <>
                    <Badge color="error">{error}</Badge>
                    <Spacer y={1} />
                </>
                : null}
            <Spacer y={1} />
            <Row justify='center'>
                <Input
                    aria-label='Prénom'
                    width="300px"
                    size='lg'
                    placeholder="Prénom"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                />
                <Spacer x={1} />
                <Input
                    aria-label='Nom'
                    width="300px"
                    size='lg'
                    placeholder="Nom"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                />
            </Row>
            <Spacer y={1} />
            <Row justify='center'>
                <Input
                    aria-label='Mot de passe'
                    width="300px"
                    size='lg'
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                />
                <Spacer x={1} />
                <Input
                    aria-label='Confirmer le mot de passe'
                    width="300px"
                    size='lg'
                    placeholder="Confirmer le mot de passe"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    type="password"
                />

            </Row>
            <Spacer y={1} />
            <Row justify='center'>
            <Input
                    aria-label='Email'
                    width="300px"
                    size='lg'
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Spacer x={1} />    
                <Input
                    aria-label='Code confidentiel'
                    width="300px"
                    size='lg'
                    placeholder="Code confidentiel"
                    value={confidentialCode}
                    onChange={(e) => setConfidentialCode(e.target.value)}
                    helperColor="primary"
                    helperText="Code confidentiel fourni par l'administrateur."
                />
            </Row>
            <Spacer y={2} />
            <Row justify='center'>
            <Input
                    aria-label='Nom de l"expéditeur'
                    width="300px"
                    size='lg'
                    placeholder="Nom de l'expéditeur"
                    value={senderName}
                    onChange={(e) => setSenderName(e.target.value)}
                    helperColor="primary"
                    helperText="Ce nom est fourni par l'administrateur."
                />
            </Row> 
            <Spacer y={2} />
            <Row justify='center'>
                {
                    loading ? (
                        <Button disabled auto bordered color="success" css={{ px: "$13" }}>
                        <Loading type="spinner" color="currentColor" size="sm" />
                        </Button>
                        ) : (
                            <Button
                            size='lg'
                            type='submit'
                            color="success"
                            shadow
                            onClick={(e) => handleSubmit(e)}
                            >
                            S'inscrire
                            </Button>
                    )
                }
                <Spacer x={1} />
                 <Button
                    size='lg'
                    type='submit'
                    color="primary"
                    onClick={() => navigate('/')}
                    >
                    Retour à la connexion
                </Button>
            </Row>
        </Container>
    )
}

export default Register
    